import {MapContainer} from "../../AssetListScreenStyles";
import React, {useContext, useState, useEffect} from "react";
import {KmlLayer, GoogleMap as GoogleMapReact, withGoogleMap, withScriptjs, OverlayView} from "react-google-maps"
import {WithGoogleMapProps} from "react-google-maps/lib/withGoogleMap";
import {reducer} from "../../../../../../context";
import {MarkerWrapper} from "./Sections/MarkerWrapper";
import {MapInfoBubble} from "./Sections/MapInfoBubble";
import {LocationBounds, LocationType} from "../../../../../../interface/Client/index";
import actionType from "../../../../../../context/actionType";
import { Asset } from "../../../../../../interface/Server";
// import GoogleMapReact from "google-map-react";

interface Props extends WithGoogleMapProps {
    [key: string]: any,
    onSelectAsset: (asset: Asset) => void,
}

const DEFAULT_ZOOM = 17;
const DEFAULT_MAP_POSITION = {
    lat: 22.3008499,
    lng: 114.1572022
};
let mapRef : any;

const Index: React.FunctionComponent<Props> = props => {
    const [showOverlay, setShowOverlay] = useState(false);
    const [zoom, setZoom] = useState(DEFAULT_ZOOM);
    const [overlayPosition, setPosition] = useState({ lat: 0, lng: 0 });
    const {googleMapReducer} = useContext(reducer);
    const setOverlayWithMarkerPosition = (setOpen: boolean) => {
        if(googleMapReducer.state.selectedMarker
         && googleMapReducer.state.selectedMarker.position
         && typeof googleMapReducer.state.selectedMarker.position.lat === 'number'
         && typeof googleMapReducer.state.selectedMarker.position.lng === 'number'
        ) {
            setShowOverlay(!setOpen);
            setPosition({
                lat: googleMapReducer.state.selectedMarker.position.lat,
                lng: googleMapReducer.state.selectedMarker.position.lng,
            });
        }
    };
    const getBounds = (): LocationBounds | null => {
        if (mapRef && mapRef.getBounds) {
            const topRight = mapRef.getBounds().getNorthEast();
            const bottomLeft = mapRef.getBounds().getSouthWest();
            const bottomRight = {
                lat: bottomLeft.lat(),
                lon: topRight.lng(),
            }
            const topLeft = {
                lat: topRight.lat(),
                lon: bottomLeft.lng(),
            }
            return {
                bottom_right: bottomRight,
                top_left: topLeft,
            }
        }
        return null;
    }
    const dispatchMapBounds = (bounds: LocationBounds, center: LocationType ) => {
        googleMapReducer.dispatch(
            {
                type: actionType.googleMap.GOOGLE_MAP_SET_MAP_BOUNDS,
                payload: {
                    mapBounds: bounds,
                    center,
                }
    
            }
        );
    };
    const getCenterOnChange = () => {
        if (mapRef && mapRef.getCenter) {
            return {
                lat: mapRef.getCenter().lat(),
                lng: mapRef.getCenter().lng(), 
            }
        }
        return undefined;
    }
    const onZoomChanged = () => {
        if (mapRef && mapRef.getZoom) setZoom(mapRef.getZoom())
    }
    const getCurrentMapCenter = () => {
        if(googleMapReducer.state.selectedMarker
        && googleMapReducer.state.selectedMarker.position
        && !!googleMapReducer.state.selectedMarker.position.lat
        && !!googleMapReducer.state.selectedMarker.position.lng) {
            return googleMapReducer.state.selectedMarker.position;
        }
        if(googleMapReducer.state.center) {
            return googleMapReducer.state.center;
        }
        return DEFAULT_MAP_POSITION;
    }
    useEffect(() => {
        if(!googleMapReducer.state.selectedMarker && !googleMapReducer.state.center && !googleMapReducer.state.mapBounds && zoom !== DEFAULT_ZOOM) {
            setZoom(DEFAULT_ZOOM);
        }
    }, [googleMapReducer]);
    useEffect(() => {
        setShowOverlay(true);
    }, [googleMapReducer.state.selectedMarker]);
    return (
        <MapContainer>
            <GoogleMapReact
                ref={(ref: any) => mapRef = ref}
                // onClick={() => setShowOverlay(false)} // TODO: tentatively hide this method so that user can select asset from map
                onDragStart={() => setShowOverlay(false)}
                onDragEnd={() => {
                    const bounds = getBounds();
                    const center = getCenterOnChange();
                    if(bounds && center) {
                        dispatchMapBounds(bounds, center);
                    }
                }}
                onZoomChanged={() => {
                    const bounds = getBounds();
                    const center = getCenterOnChange();
                    if(bounds && center) {
                        dispatchMapBounds(bounds, center);
                    }
                    onZoomChanged();
                }}
                // check if onResize is needed 
                defaultOptions={
                    {
                        mapTypeControl: false,
                        fullscreenControl: false,
                        zoomControl: true,
                        streetViewControl: false
                    }
                }
                // center={googleMapReducer.state.markers && googleMapReducer.state.markers[0] ? googleMapReducer.state.markers[0].position : {
                //     lat: 22.3008499,
                //     lng: 114.1572022
                // }}
                defaultCenter={googleMapReducer.state.markers && googleMapReducer.state.markers[0]
                    ? googleMapReducer.state.markers[0].position
                    : DEFAULT_MAP_POSITION
                }
                defaultClickableIcons={false}
                center={getCurrentMapCenter()}
                zoom={zoom}
            >

                {// TODO: add nearby markers of donors (need to known API repsonse format)
                    /* {googleMapReducer.state.markers && googleMapReducer.state.markers.map((n, i) => <MarkerWrapper
                    assetVariant={n}/>)} */}
                {googleMapReducer && googleMapReducer.state && googleMapReducer.state.markers && googleMapReducer.state.markers.map((n, i) => 
                    n === googleMapReducer.state.selectedMarker && showOverlay ? null :
                    <MarkerWrapper
                        key={n.assetId}
                        assetVariant={n}
                        onPressMarker={setOverlayWithMarkerPosition}
                    />
                )}
                {showOverlay && googleMapReducer && googleMapReducer.state.selectedMarker &&
                    <MapInfoBubble
                        // onClose={() => { setShowOverlay(false)}}
                        onSelectAsset={() => props.onSelectAsset && googleMapReducer.state.selectedMarker && props.onSelectAsset(googleMapReducer.state.selectedMarker)}
                        position={googleMapReducer.state.selectedMarker.position}
                        image={googleMapReducer.state.selectedMarker.images && googleMapReducer.state.selectedMarker.images[0]}
                        name={googleMapReducer.state.selectedMarker.inventoryId}
                        technicalName={googleMapReducer.state.selectedMarker.technicalName}
                        englishName={googleMapReducer.state.selectedMarker.englishName}
                        price={googleMapReducer.state.selectedMarker.giftAmount}
                        currency={googleMapReducer.state.selectedMarker.giftAmountCurrency}
                    />
                }
                {/* <KmlLayer
                    url="http://128.199.67.222:8080/adms/asset/files/doc.kml"
                    options={{ preserveViewport: true }}
                /> */}
            </GoogleMapReact>
        </MapContainer>
    )
};


export default withScriptjs(withGoogleMap(Index))